import { NeoState } from '~/store/Reducers.interface';

export const selectMockModeState = (state: NeoState) => state.app.mocks.isInMockMode;
export const selectMockedUserView = (state: NeoState) => state.app.mocks.userView;
export const selectMockedAppView = (state: NeoState) => state.app.mocks.appView;
